<template>
  <Header />

  <GiftAdd />

  <Footer />
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import GiftAdd from "@/components/GiftAdd.vue";

export default {
  name: "GiftView",
  components: {
    Header,
    Footer,
    GiftAdd,
  },
  created() {
    if (this.$store.state.user.data.plan !== 'paid' && this.$store.state.giftMap.length > 5) {
      this.$router.push('/gifts')
    };
  },
};
</script>
